export const SHORT_DATE_FORMAT = 'MMM D, YYYY';
